import { useContext } from "react";
import { Header } from "../../components/header/Header";
import { ProtectedRoutes } from "../../routes/ProtectedRoutes";
import { Footer } from "../../components/footer/Footer";
import { AppContext } from "../../context";

export const MainLayout = () => {
    const {
        t,
        appState: { user },
    } = useContext(AppContext);

    return (
        <div>
            <header>
                <Header
                    welcomeMessage={t("Dashboard.welcomeTitle")}
                    userName={user?.name}
                />
            </header>
            <main style={{ marginTop: '80px' }}>
                <ProtectedRoutes />
            </main>
            <footer>
                <Footer />
            </footer>
        </div>
    )
};
